import { useEffect, useState } from 'react';
const usePaymentSession = (url) => {
    const [state] = useState({
        loaded: false,
        error: false,
    });

    useEffect(() => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
        // If cachedScripts array already includes src that means another instance ...
        // ... of this hook already loaded this script, so no need to load again.
        //   if (cachedScripts.includes(url)) {
        //     setState({
        //       loaded: true,
        //       error: false
        //     });
        //   }else {
        //     cachedScripts.push(url);

        //     // Create script
        //     let script = document.createElement('script');
        //     script.src = url;
        //     script.async = false;

        //     // Script event listener callbacks for load and error
        //     const onScriptLoad = () => {
        //       setState({
        //         loaded: true,
        //         error: false
        //       });
        //     };

        //     const onScriptError = () => {
        //       // Remove from cachedScripts we can try loading again
        //       const index = cachedScripts.indexOf(url);
        //       if (index >= 0) cachedScripts.splice(index, 1);
        //       script.remove();

        //       setState({
        //         loaded: true,
        //         error: true
        //       });
        //     };

        //     script.addEventListener('load', onScriptLoad);
        //     script.addEventListener('error', onScriptError);

        //     // Add script to document body
        //     document.body.appendChild(script);

        //     // Remove event listeners on cleanup
        //     return () => {
        //       script.removeEventListener('load', onScriptLoad);
        //       script.removeEventListener('error', onScriptError);
        //     };
        //   }
    }, [url]);

    return [state.loaded, state.error];
};

export default usePaymentSession;
